function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 45.6517V0H60.6667V13H34.6667V60.6667C34.6658 64.4822 33.4061 68.1908 31.0827 71.2173C28.7594 74.2439 25.5024 76.4193 21.8167 77.4062C18.1311 78.3932 14.2228 78.1364 10.6979 76.6758C7.17308 75.2151 4.22865 72.6323 2.32128 69.3278C0.413903 66.0232 -0.349836 62.1817 0.148504 58.3989C0.646844 54.6161 2.37942 51.1034 5.07753 48.4056C7.77564 45.7078 11.2885 43.9756 15.0714 43.4777C18.8542 42.9798 22.6957 43.7439 26 45.6517Z",
  fill: "#93A0B7"
});

function SvgGameAudioMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 78,
    viewBox: "0 0 61 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameAudioMusic);
export default __webpack_public_path__ + "static/media/game-audio-music.d35f79cd.svg";
export { ForwardRef as ReactComponent };